import { render, staticRenderFns } from "./featureBlock.vue?vue&type=template&id=1ed9629f&scoped=true&"
import script from "./featureBlock.vue?vue&type=script&lang=js&"
export * from "./featureBlock.vue?vue&type=script&lang=js&"
import style0 from "./featureBlock.vue?vue&type=style&index=0&id=1ed9629f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9629f",
  null
  
)

export default component.exports